import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationUserDto } from "@entities/commonTypes";

export interface SwipeState {
  currentUser: ApplicationUserDto | null;
  reactionType: boolean | null;
  showHintForm: boolean;
  fromMatchComponent: boolean;
  lastViewedUser: ApplicationUserDto | null;
}

const initialState: SwipeState = {
  currentUser: null,
  reactionType: null,
  showHintForm: false,
  fromMatchComponent: false,
  lastViewedUser: null,
};

export const SWIPE_SLICE_KEY = "swipe";

export const swipeSlice = createSlice({
  name: SWIPE_SLICE_KEY,
  initialState,
  reducers: {
    setCurrentUser: (
      state,
      action: PayloadAction<{ user: ApplicationUserDto; liked: boolean }>
    ) => {
      state.currentUser = action.payload.user;
      state.reactionType = action.payload.liked;
    },
    setFromMatchComponent: (state, action: PayloadAction<boolean>) => {
      state.fromMatchComponent = action.payload;
    },
    setLastViewedUser: (state, action: PayloadAction<ApplicationUserDto>) => {
      state.lastViewedUser = action.payload;
    },
    clearCurrentUser: (state) => {
      state.currentUser = null;
      state.reactionType = null;
    },
    clearLastViewedUser: (state) => {
      state.lastViewedUser = null;
    },
    toggleHintForm: (state) => {
      state.showHintForm = !state.showHintForm;
    },
    setShowHintForm: (state, action: PayloadAction<boolean>) => {
      state.showHintForm = action.payload;
    },
  },
});

export const {
  setCurrentUser,
  clearCurrentUser,
  toggleHintForm,
  setFromMatchComponent,
  setLastViewedUser,
  clearLastViewedUser,
  setShowHintForm,
} = swipeSlice.actions;
